
import { Avatar, Box, Chip, Grid, LinearProgress, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Typography } from "@mui/material";
import { IEAbhyasSharedFileComponentProps, ISchoolFileSharing, IShareFileShareComponentProps, IShareFileShareRequest, ISharedFile, ISharedFileComponentProps, ISharedFileDeleteRequest, ISharedFileUploadRequest, SharedFilePurpose } from "./sharedFilesModel";
import React, { useEffect, useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ShareIcon from '@mui/icons-material/Share';
import { toast } from "react-toastify";
import SharedFileService from "./sharedFileService";
import ProgramFileUploadComponent from "../programFileUpload/programFileUpload";
import { FileTypeIcon } from "../../common/components/FileTypeIcon";
import { LoadingButton } from "@mui/lab";
import { EAbhyasFileShareComponent } from "./eabhyasFileShare";
import moment from "moment";
import { ISchoolModel, ISchoolSummaryModel } from "../../facilitator/models/ISchoolModel";
import { getFileNameWithOutExt } from "../../common/utilities/utils";

export const EAbhyasFilesComponent = (props: IEAbhyasSharedFileComponentProps) => {
    const { eabhyasFilesAdd, eabhyasFilesDelete, eabhyasFilesShare, selectedSchoolId } = props;
    const [schoolFiles, setSchoolFiles] = useState<ISharedFile[]>([]);
    const [filesLoading, setFilesLoading] = useState<boolean>(false);
    const [fileUploadIsInProgress, setFileUploadIsInProgress] = useState<boolean>(false);
    const [shareDrawerOpen, setShareDrawerOpen] = useState<boolean>(false);
    const [isShareInProgress, setShareInProgress] = useState<boolean>(false);
    const [shareSchoolFile, setShareSchoolFile] = useState<ISharedFile>(schoolFiles[0]);

    const loadFiles = () => {
        setFilesLoading(true);
        SharedFileService.getEbhyasFiles(selectedSchoolId ?? undefined).then((result) => {
            if (result.data.errors && result.data.errors.length > 0) {
                toast.error(result.data.errors[0].message);
            } else {
                setSchoolFiles(result.data.list);
            }
        }).finally(() => setFilesLoading(false));
    }
    useEffect(() => {
        loadFiles();
    }, [selectedSchoolId]);
    const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const uploadedFiles = Array.from(e.target.files || []);
        setFileUploadIsInProgress(true);
        SharedFileService.fileUpload(uploadedFiles, { purpose: SharedFilePurpose.EAbhyasFiles } as ISharedFileUploadRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in uploading the files");
                }
                else {
                    setSchoolFiles([...schoolFiles, ...response.data.list]);
                }
            }).finally(() => {
                setFileUploadIsInProgress(false);

            });
    }

    const updateSchoolFiles = (updatedFiles: ISharedFile[]) => {
        setSchoolFiles(updatedFiles);
    }

    const handleFileDelete = (fileDetails: ISharedFile) => {
        if (!window.confirm(`Delete "${getFileNameWithOutExt(fileDetails.fileName)}"?`)) return;
        const programFiles = schoolFiles;
        const fileIndex = programFiles.findIndex(i => i.fileId === fileDetails.fileId);
        programFiles[fileIndex] = { ...fileDetails, isDeleteInProgress: true };
        setSchoolFiles(programFiles);

        SharedFileService.deleteFile({ schoolFileId: fileDetails.fileId } as ISharedFileDeleteRequest)
            .then((response) => {
                if (response.data.errors !== undefined && response.data.errors !== null && response.data.errors.length > 0) {
                    toast.error("error in deleting the files");
                }
                else {
                    const programFilesData = schoolFiles.filter(i => i.fileId !== fileDetails.fileId);
                    setSchoolFiles([...programFilesData]);
                    toast.success("file deleted successfully");
                }
            }).finally(() => {


            });
    }

    const handleDownloadClick = (programFile: ISharedFile) => {
        const fileDownloadUrl = SharedFileService.getFileDownloadUrl(programFile.fileId);
        window.open(fileDownloadUrl, '_blank');
    }
    const updateSchoolFileShare = (fileDetails: ISharedFile, schools: ISchoolSummaryModel[]) => {
        setShareInProgress(true);
        SharedFileService.shareFile({ schoolFileId: fileDetails.fileId, schoolIds: schools.map(i => i.userId) } as IShareFileShareRequest).then((res) => {
            if (res.data.errors != undefined && res.data.errors.length > 0) {
                toast.error(res.data.errors[0].message);
            }
            else {
                updateSchoolFiles([...schoolFiles.filter(i => i.fileId !== res.data.data.fileId), res.data.data])

                closeShareDrawer();
                toast.success('Files shared successfully');
            }
        }).catch(() => {

        }).finally(() => {
            setShareInProgress(false);
        });
    }
    const handleShareClick = (fileDetails: ISharedFile) => {
        setShareSchoolFile(fileDetails);
        setShareInProgress(false);
        setShareDrawerOpen(true);
    }
    const closeShareDrawer = () => {
        setShareDrawerOpen(false);
        setShareInProgress(false);
    }

    return (
        <>
            {eabhyasFilesAdd && <ProgramFileUploadComponent handleFileChange={handleFileUpload} fileUploadIsInProgress={fileUploadIsInProgress}></ProgramFileUploadComponent>}
            <TableContainer sx={{
                width: "100%",
                maxHeight: "70vh",
                minHeight: "70vh",
                overflowY: "auto",
                // ...tableSxProps
            }}>
                {filesLoading && <LinearProgress sx={{ position: 'sticky', top: 0, zIndex: 2 }} />}
                <Table sx={{ minWidth: 650 }} aria-label="files table" stickyHeader>
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>File Name</TableCell>
                            {eabhyasFilesShare && <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>Shares</TableCell>}
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>Uploaded Date</TableCell>
                            <TableCell sx={{ fontWeight: 600, fontSize: '0.72rem', color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.06em', bgcolor: 'grey.50' }}>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {schoolFiles.length === 0 && !filesLoading && (
                            <TableRow>
                                <TableCell colSpan={4} align="center">
                                    <Typography color="text.secondary" sx={{ py: 4 }}>No files uploaded yet.</Typography>
                                </TableCell>
                            </TableRow>
                        )}
                        {schoolFiles.map((programFile) => (
                                <TableRow key={programFile.fileId} sx={{ '&:hover': { bgcolor: 'action.hover' } }}>
                                    <TableCell style={{ maxWidth: '50%' }}>
                                        <Stack direction="row" alignItems="center" spacing={1}>
                                            <FileTypeIcon fileName={programFile.fileName} />
                                            <Typography sx={{ fontSize: '0.875rem' }}>{getFileNameWithOutExt(programFile.fileName)}</Typography>
                                        </Stack>
                                    </TableCell>
                                    {eabhyasFilesShare && <TableCell>
                                        <Chip avatar={<Avatar>{programFile.schoolSharings.length}</Avatar>} label="Shares" color="primary" variant="outlined" size="small" />
                                    </TableCell>}
                                    <TableCell sx={{ color: 'text.secondary', fontSize: '0.8rem' }}>{moment(programFile.uploadedOn).format('DD-MMM-YYYY HH:mm')}</TableCell>
                                    <TableCell sx={{ whiteSpace: 'nowrap' }}>
                                        <Stack direction="row" spacing={1}>
                                            <LoadingButton
                                                loading={programFile.isDeleteInProgress}
                                                variant="contained"
                                                size="small"
                                                startIcon={<CloudDownloadIcon />}
                                                loadingPosition="start"
                                                onClick={() => handleDownloadClick(programFile)}
                                            >
                                                Download
                                            </LoadingButton>
                                            {eabhyasFilesShare && (
                                                <LoadingButton
                                                    variant="outlined"
                                                    size="small"
                                                    startIcon={<ShareIcon />}
                                                    onClick={() => handleShareClick(programFile)}
                                                >
                                                    Share
                                                </LoadingButton>
                                            )}
                                            {eabhyasFilesDelete && (
                                                <LoadingButton
                                                    loading={programFile.isDeleteInProgress}
                                                    variant="outlined"
                                                    color="error"
                                                    size="small"
                                                    startIcon={<DeleteIcon />}
                                                    loadingPosition="start"
                                                    onClick={() => handleFileDelete(programFile)}
                                                >
                                                    Delete
                                                </LoadingButton>
                                            )}
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}

                    </TableBody>
                </Table>
            </TableContainer>
            {shareDrawerOpen && <EAbhyasFileShareComponent isShareInProgress={isShareInProgress} updateSchoolFileShare={updateSchoolFileShare} handleClose={closeShareDrawer} schoolFile={shareSchoolFile}></EAbhyasFileShareComponent>}
        </>
    );
}